import { render, staticRenderFns } from "./DownloadSpreadsheetModal.vue?vue&type=template&id=97020fb8&scoped=true&"
import script from "./DownloadSpreadsheetModal.vue?vue&type=script&lang=js&"
export * from "./DownloadSpreadsheetModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSpreadsheetModal.vue?vue&type=style&index=0&id=97020fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97020fb8",
  null
  
)

export default component.exports